






























































































import { Component, Mixins } from 'vue-property-decorator';

import SignUpService from '@/api/SingupService';

import { updateRegistration } from '@/utils/updateRegistration';

import { ConfigFormData } from '@/models/onboarding';

import { validation as formValidate } from '@/views/Onboarding/Steps/Refund/validation';

import Page from '@/componentsV2/molecules/Page/Page.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import RefundConfigForm from '@/components/organisms/RefundConfigForm/RefundConfigForm.vue';
import LoyaltyExample from '@/components/molecules/LoyaltyExample/LoyaltyExample.vue';
import { treatError } from '@/utils';

import BusinessService from '@/api/BusinessService';
import LoyaltySetupBase from '@/views/Onboarding/Steps/LoyaltySetup/LoyaltySetupBase.vue';
import SellCoinsService from '@/api/SellCoinsService';
import LoyaltyConfigForm from '@/components/organisms/LoyaltyConfigForm/LoyaltyConfigForm.vue';
import InfoIcon from '@/components/icons/Info.vue';
import { Typography } from '@/components/atoms';
import DiscountIcon from '@/components/icons/Discount.vue';
import SocialMediaIcon from '@/components/icons/SocialMedia.vue';
import CalendarIcon from '@/components/icons/Calendar.vue';
import eventBus from '@/utils/eventBus';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import { DashboardScreen } from '@/api/enums/dashboard-screen.enum';
import {
  EAutomaticCampaignName,
  EIncentiveType,
  ESellCoinsCampaignStatus
} from '@/models/sell-coins';
import DateUtils from '@/utils/DateUtils';
import { Campaign, TCampaignStatus } from '@/models/marketingCenter/sellCoins';
import flagKeys from '@/constants/flagKeys';

@Component({
  components: {
    Page,
    RefundConfigForm,
    LoyaltyConfigForm,
    FilledButton,
    InfoIcon,
    Typography,
    LoyaltyExample,
    DiscountIcon,
    SocialMediaIcon,
    CalendarIcon
  }
})
export default class LoyaltyRewards extends Mixins(LoyaltySetupBase) {
  signUpService = new SignUpService();
  businessService: BusinessService = new BusinessService();
  sellCoinsService: SellCoinsService = new SellCoinsService();
  iconName: string = 'warning.svg';
  campaignStatusType: TCampaignStatus = 'campaignRatioIssueActivation';

  isCreatingLoyalty: boolean = false;

  formDataRefund: any = {
    type: null,
    value: undefined,
    customValue: '',
    state: {},
    customValueFocused: false
  };

  formData: any = {
    type: null,
    value: undefined,
    customValue: '',
    state: {},
    customValueFocused: false
  };
  loadingSubmit = false;

  get title() {
    return 'Rewards Rate';
  }

  get isValidForm() {
    return formValidate(this.formDataRefund) && formValidate(this.formData);
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get tPrefixLoyalty() {
    return 'common.components.loyaltyExample';
  }

  get currencyName() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencyShorthand;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get isLoyaltyEnabled() {
    if (!this.$store.getters['business/getRewardStatus']) return false;

    return (
      this.$store.getters['business/getRewardStatus'].operationStatus ===
      'active'
    );
  }

  get buttonText() {
    if (Number(this.businessInfo.coinPurchaseRatio) === 0)
      return 'Create Loyalty Program';

    if (!this.isLoyaltyEnabled) {
      return 'Activate Loyalty Program';
    }

    return 'Update Loyalty Program';
  }

  formatDate(date: any) {
    if (date && date !== null) {
      const [formatedDate] = date.split('T');
      return DateUtils.formattedDate({ date: formatedDate });
    }

    return 'No expiration date';
  }

  newCampaignEndDateFormatted(newCampaignData: Campaign) {
    if (newCampaignData && newCampaignData.endDate) {
      return DateUtils.formattedDate({
        date: newCampaignData.endDate
      });
    }

    return 'No expiration date';
  }

  openCampaignStatusManagementModal(
    activeCampaignData?: any,
    newCampaignData?: any
  ) {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        icon: 'none',
        hideCancelButton: true,
        confirmEvent: '',
        componentToRender: 'SellCoinsCampaignStatusManagementModal'
      }),
      {
        iconName: this.iconName,
        campaignType: this.campaignStatusType,
        activeCampaignData,
        newCampaignData: {
          ...newCampaignData,
          endDate: this.newCampaignEndDateFormatted(newCampaignData)
        },
        onConfirm: async (optionSelected: string) => {
          this.loadingSubmit = true;
          try {
            if (optionSelected === 'createNewCampaign') {
              await this.sellCoinsService.deactivateActiveCampaign();

              const listOfCampaigns = await this.sellCoinsService.listOfCampaigns();
              const matchCampaign = listOfCampaigns.data.items.find(
                (item: any) =>
                  item.incentiveValue ===
                    parseFloat(newCampaignData.incentiveValue) &&
                  item.status === ESellCoinsCampaignStatus.INACTIVE
              );

              if (matchCampaign) {
                await this.sellCoinsService.changeCampaignStatus(
                  matchCampaign.id
                );
              } else {
                await this.sellCoinsService.createSellingCoinsCampaign({
                  name: EAutomaticCampaignName.loyalt,
                  incentiveValue: parseFloat(newCampaignData.incentiveValue),
                  incentiveType: EIncentiveType.BONUS,
                  automaticallyCreated: true
                });
              }
            } else if (optionSelected === 'disableSellCoins') {
              const response = await this.businessService.updateSellCoins(
                !this.businessInfo.sellCoins,
                DashboardScreen.Loyalt
              );

              this.$store.dispatch('business/SET_BUSINESS_INFO', {
                ...this.businessInfo,
                sellCoins: response.data.sellCoins
              });
            }
          } finally {
            this.loadingSubmit = false;
          }
          this.onSubmit();
        }
      }
    );
  }

  handleChangeRefundConfig(formData: ConfigFormData) {
    this.formDataRefund = formData;

    this.$store.dispatch('rewardsProgram/SET_FORM_DATA', {
      refundPolicy: formData
    });
  }

  handleChangeFormData(formData: ConfigFormData) {
    this.$store.dispatch('rewardsProgram/SET_FORM_DATA', {
      rewardRatio: formData
    });

    this.formData = formData;
  }

  async onClick() {
    if (!this.isValidForm) {
      this.$notification('Please select an option', 'error');

      return;
    }

    if (
      !this.isLoyaltyEnabled &&
      Number(this.businessInfo.coinPurchaseRatio) > 0
    ) {
      this.$store.dispatch('business/SET_BUSINESS_INFO', {
        ...this.businessInfo,
        coinRewardPercentage: this.percentInCoins
      });
      this.onOpenModal({
        data: {
          type: 'openLoyaltyModal',
          data: {
            activeRewards: true
          },
          onSuccess: () => {
            this.onClick();
          }
        }
      } as MessageEvent);
      return;
    }

    this.loadingSubmit = true;
    try {
      const response = await this.sellCoinsService.getActiveCampaign();
      const activeCampaign = response.data;

      const listOfCampaigns = await this.sellCoinsService.listOfCampaigns();
      const activeCampaignWithNewLoyalt = listOfCampaigns.data.items.find(
        (item: { incentiveValue: number; status: ESellCoinsCampaignStatus }) =>
          item.incentiveValue === this.percentInCoins &&
          item.status === ESellCoinsCampaignStatus.ACTIVE
      );

      if (
        this.flags.includes(flagKeys.dashboardSellCoinsAndLoyaltVerify) &&
        this.businessInfo.sellCoins &&
        ((activeCampaign.incentiveValue &&
          this.percentInCoins > activeCampaign.incentiveValue) ||
          activeCampaign.incentiveValue === 0) &&
        !activeCampaignWithNewLoyalt
      ) {
        activeCampaign.endDate = this.formatDate(activeCampaign.endDate);
        const newCampaign = {
          ...activeCampaign,
          incentiveValue: this.percentInCoins.toString()
        };

        this.openCampaignStatusManagementModal(activeCampaign, newCampaign);
      } else {
        await this.onSubmit();
      }
    } finally {
      this.loadingSubmit = false;
    }
  }

  async onSubmit() {
    if (!this.isValidForm) {
      this.$notification('Please select an option', 'error');

      return;
    }

    const { customValue, value } = this.formDataRefund;

    const payload: any = {
      refundsLimitDays: value || customValue,
      coinPurchaseRatio: this.coinPurchaseRatio,
      coinRewardPercentage: this.percentInCoins
    };

    this.loadingSubmit = true;

    try {
      const response = await this.signUpService.setupRules(payload);
      if (response && response.data) {
        this.$store.dispatch('business/SET_BUSINESS_INFO', {
          ...this.businessInfo,
          refundsLimitDays: response.data.refundsLimitDays,
          coinRewardPercentage: response.data.coinRewardPercentage,
          coinPurchaseRatio: response.data.coinPurchaseRatio
        });
        this.$store.dispatch('business/SET_REWARD_STATUS', {
          ...this.$store.getters['business/getRewardStatus'],
          operationStatus: 'active',
          rewardStatus: 'active'
        });

        window.parent.postMessage(
          {
            type: 'loyalty:campaign-created',
            data: response.data
          },
          '*'
        );

        await Promise.all([
          updateRegistration('manage-rewards'),
          updateRegistration('return-policy')
        ]);

        this.$notification(`Loyalty set up successfully`, 'success');
        if (this.isCreatingLoyalty) {
          this.$router.push('/my-programs');
        }
      }
    } catch (e) {
      treatError(e);
    } finally {
      this.loadingSubmit = false;
    }
  }

  onOpenModal(event: MessageEvent) {
    if (event.data.data && event.data.data.rewardData) {
      this.$store.dispatch(
        'business/SET_REWARD_STATUS',
        event.data.data.rewardData
      );
    }
    if (event.data.type === 'openLoyaltyModal') {
      eventBus.$emit(
        'openSubModal',
        new ModalOptionsV2({
          componentToRender: `toggleRewardsModal`,
          hideCancelButton: true,
          icon: '',
          mobilePositionBottom: true,
          mobileFullScreen: true
        }),
        {
          mobilePositionBottom: true,
          activeRewards: event.data.data.activeRewards,
          type: 'physical',
          onSuccess: async () => {
            window.parent.postMessage(
              { type: 'loyalty:toggle', data: {} },
              '*'
            );
            this.$store.dispatch('business/SET_REWARD_STATUS', {
              ...this.$store.getters['business/getRewardStatus'],
              operationStatus: event.data.data.activeRewards
                ? 'active'
                : 'inactive'
            });

            if (event.data.onSuccess) event.data.onSuccess();
          },
          group: {
            id: 'loyalty-program'
          },
          origin: 'switch'
        }
      );
    }
  }

  created() {
    this.isCreatingLoyalty = Number(this.businessInfo.coinPurchaseRatio) === 0;
    window.addEventListener('message', this.onOpenModal);
  }

  beforeDestroy() {
    window.removeEventListener('message', this.onOpenModal);
  }
}
